<!--集团新闻-->
<template>
  <div class="new-page">
    <div class="page-banner flex-column-c-c">
      <div class="banner-title">集团新闻</div>
      <div class="banner-line"></div>
    </div>
    <div class="news-box">
      <div class="news-header">
        <div class="font70">GROUP NEWS</div>
        <div class="font50">集团新闻</div>
      </div>
      <div class="news-list flex-wrap" v-if="newsList.length > 0">
        <div class="news-item" v-for="(item,index) in newsList" :key="index">
          <router-link :to="`/detail?id=${item.id}`" class="item-banner flex" v-if="index === 0">
            <div class="banner-img">
              <img class="img-cover" :src="`${ajaxUrl}${item.image}`" alt="">
            </div>
            <div class="banner-intro">
              <div class="intro-date">{{item.publish_at}}</div>
              <div class="intro-title ellipsis_2">{{item.title}}</div>
              <div class="intro-con">
               {{item.description}}
              </div>
              <div class="intro-btn flex-c-c">
                MORE
                <img src="../assets/news/more_arrow_right.png" alt="">
              </div>
            </div>
          </router-link>
          <router-link :to="`/detail?id=${item.id}`" class="item-card" v-else>
            <div class="card-img">
              <img class="img-cover" :src="`${ajaxUrl}${item.image}`" alt="">
            </div>
            <div class="card-intro flex-c">
              <div class="intro-date flex-column-c-c">
                {{item.year}}
                <div class="date-line"></div>
                <span class="font20">{{item.day}}</span>
              </div>
              <div class="intro-title flex-auto ellipsis_1">{{item.title}}</div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="news-list flex-c-c" v-else>
        <el-empty></el-empty>
      </div>
      <div class="new-pagination flex-c-c" v-if="newsList.length > 0">
        <el-pagination background layout="prev, pager, next" :page-size="newsPage.pageSize" @current-change="onChangePageCurrent" :current-page="newsPage.currentPage" :total="newsPage.total"></el-pagination>
      </div>
    </div>
    <div class="staff-box">
      <div class="staff-header">
        <div class="font70">STAFF</div>
        <div class="font50">员工风采</div>
      </div>
      <swiper class="staff-banner" :options="documentWidth < 750 ? swiperOptionApp : swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-item" v-for="(item,index) in staffList" :key="index">
          <router-link :to="`/detail?id=${item.id}`" class="staff-item">
            <div class="item-img">
              <img class="img-cover" :src="`${ajaxUrl}${item.image}`" alt="">
            </div>
            <div class="item-title ">
              <div class="ellipsis_1">{{item.title}}</div>
            </div>
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
<!--    <MessageFrom></MessageFrom>-->
    <Footer></Footer>
  </div>
</template>

<script>
  import MessageFrom from "../components/MessageFrom";
  import {ajaxPost,ajaxUrl} from "../utils/ajax";
  import Footer from "../components/Footer";
  export default {
    name: "News",
    data(){
      return {
        ajaxUrl,
        newsPage:{
          currentPage: 1,
          pageSize: 4,
          total: null,
        },
        newsList:[],
        staffList:[],
        swiperOption:{
          loop: true,
          slidesPerView: 3,
          spaceBetween: 50,
          autoplay: {
            disableOnInteraction: false,
            delay: 5000,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        swiperOptionApp:{
          loop: true,
          slidesPerView: 2,
          spaceBetween: 10,
          autoplay: {
            disableOnInteraction: false,
            delay: 3000,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        documentWidth: document.body.clientWidth,
      }
    },
    components: {Footer, MessageFrom},
    mounted() {
      this.$emit('handleRed', false);
      this.fetchNewsList();
      this.fetchStarList();
    },
    methods: {
      fetchNewsList(){
        if(document.body.clientWidth < 750) {
          this.newsPage = {
            ...this.newsPage,
            pageSize: 3,
          }
        }
        const {currentPage, pageSize} = this.newsPage;
        ajaxPost({
          url: 'ajaxArticlePage',
          params:{
            page: currentPage,
            paginate: pageSize,
            channel_id: 1,
          },
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.newsList = data.rows;
              this.newsPage = {
                ...this.newsPage,
                total: data.total,
              }
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
      fetchStarList(){
        const {currentPage, pageSize} = this.newsPage;
        ajaxPost({
          url: 'ajaxArticlePage',
          params:{
            page: 1,
            paginate: 999,
            channel_id: 2,
          },
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.staffList = data.rows;
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
      //页码改变
      onChangePageCurrent(currentPage){
        this.newsPage = {
          ...this.newsPage,
          currentPage,
        };
        this.fetchNewsList();
      },
    },
  }
</script>

<style scoped lang="scss">
  .new-page {
    width: 100%;background: $color-white;
    .page-banner {
      width: 100%;height: 730px;background: url('../assets/news/new_banner.png') no-repeat center/cover;padding-top: 2%;
      .banner-title { font-size: 60px;color: $color-white;letter-spacing: 1px;}
      .banner-line { width: 110px;height: 3px;background: $color-white;margin-top: 50px;}
    }
    .news-box {
      width:100%;background: url("../assets/common_bg.png") no-repeat top left;padding: 100px 110px;
      .news-header { color: $theme-color;line-height: 1.3;}
      .news-list {
        width: 100%;height: 1055px;margin-top: 30px;
        .news-item {
          width: 30.1%;margin-right: 4.84%;cursor: pointer;
          &:first-child { width: 100%;margin: 0;}
          &:last-child { margin-right: 0;}
          .item-banner {
            width: 100%;
            .banner-img {
              flex: 0 0 62.5%;height: 640px;overflow: hidden;
              img  { transition: .5s;&:hover { transform: scale(1.12);}}
            }
            .banner-intro {
              flex: 1 1 auto;background: $theme-color;color: $color-white;padding: 34px;
              .intro-date { margin-top: 40px;font-size: $font-size18;}
              .intro-title { font-size: 34px;margin-top: 10px;}
              .intro-con { margin-top: 40px;font-size: $font-size14;line-height: 1.9;max-height: 190px;overflow: hidden;}
              .intro-btn {
                width: 208px;height: 73px;background: rgba(255,255,255,.4);margin-top: 70px;
                font-size: $font-size16;
                img { width: 30px;margin-left: 20px;}
              }
            }
          }
          .item-card {
            margin-top: 30px;transition: .4s;display: block;width: 100%;
            .card-img {
              height: 270px;overflow: hidden;
              img  { transition: .5s;}
            }
            .card-intro {
              width: 100%;padding: 20px;background: #ECECEC;
              .intro-date {
                flex: 0 0 96px;height: 75px;background: $theme-color;font-size: $font-size18;color: $color-white;margin-right: 20px;
                .date-line { margin: 3px 0;width: 43px;height: 1px;background: $color-white;}
              }
              .intro-title { font-size: $font-size24;}
            }
            &:hover {
              box-shadow: 4px 4px 10px 4px rgba(0,0,0,.1);transform: translateY(-6px);
            }
          }
        }
      }
      .new-pagination {
        width: 100%;margin-top: 40px;
        >>> .el-pager li {
          width: 60px;height: 60px;background: rgba($theme-color,.3);color: $color-white;font-size: 26px;text-align: center;line-height: 60px;font-weight: 200;cursor: pointer;padding: 0;margin: 0 8px;border-radius: 0;
          &.active { background: $theme-color;}
        }
        >>> .btn-prev:disabled,>>> .btn-next:disabled{
          opacity: .3;
        }
        >>> .el-icon {
          width: 60px;height: 60px;background: $theme-color;color: $color-white;text-align: center;line-height: 60px;font-size: 24px;
        }
      }
    }
    .staff-box {
      width: 100%;padding: 60px 120px;background: #F0F0F0;
      .staff-header {
        color: $theme-color;line-height: 1.3;
      }
      .staff-banner {
        width: 100%;margin-top: 40px;
        .staff-item {
          width: 100%;cursor: pointer;transition: .3s;
          .item-img { width: 100%;height: 270px;}
          .item-title { font-size: $font-size24;background: #fff;padding: 36px 23px;}
          &:hover {
            box-shadow: 4px 4px 10px 4px rgba(0,0,0,.1);transform: translateY(-6px);
          }
        }
        >>> .swiper-slide { padding: 20px 10px 88px 10px;}
        >>> .swiper-pagination { bottom: 0;}
        >>> .swiper-pagination-bullet {
          width: 21px;height: 21px;background: transparent;border: 1px solid #333;position: relative;margin: 0 30px;
          &:before { position: absolute;content: '';width: 8px;height: 8px;background: #000;border-radius: 50%;top: calc(50% - 4px);left: calc(50% - 4px);}
          &.swiper-pagination-bullet-active {
            border-color: $theme-color;
            &:before { background: $theme-color;}
          }
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .new-page {
      .page-banner {
        height: 220px;padding-top: 5%;
        .banner-title { font-size: 30px;}
        .banner-line { width: 60px;height: 2px;margin-top: 14px;}
      }
      .news-box {
        padding: 20px 14px;
        .news-header {
          .font70 { font-size: 36px;}
          .font50 { font-size: 26px;}
        }
        .news-list {
          margin-top: 12px;justify-content: space-between;height: auto;
          .news-item {
            width: 49%;margin-right: 0;
            .item-banner {
              display: block;box-shadow: 0 0 8px 0 rgba(0,0,0,.2);
              .banner-img { width: 100%;height: 150px;}
              .banner-intro {
                padding: 10px;
                .intro-date { font-size: 12px;margin-top: 0;}
                .intro-title { font-size: 16px;margin-top: 5px;}
                .intro-con { font-size: 12px;margin-top: 8px;height: 44px;}
                .intro-btn {
                  margin-top: 10px;width: 90px;height: 26px;font-size: 12px;
                  img { width: 12px;margin-left: 10px;}
                }
              }
            }
            .item-card {
              margin-top: 14px;position: relative;box-shadow: 0 0 8px 0 rgba(0,0,0,.2);
              .card-img { height: 120px;}
              .card-intro {
                padding: 8px 10px;
                .intro-date {
                  width: 36px;font-size: 12px;height: 44px;margin-right: 0;position: absolute;top: 0;right: 0;background: rgba($theme-color,.5);
                  .date-line { width: 26px;margin: 1px 0;}
                  .font20 { font-size: 12px;}
                }
                .intro-title { font-size: 14px;}
              }
            }
          }
        }
        .new-pagination {
          margin-top: 16px;
          >>> .el-pager li {
            width: 30px;height: 30px;background: rgba($theme-color,.3);color: $color-white;font-size: 12px;text-align: center;line-height: 30px;cursor: pointer;padding: 0;margin: 0 4px;
          }
          >>> .el-icon {
            width: 30px;height: 30px;line-height: 30px;font-size: 14px;
          }
        }
      }
      .staff-box {
        padding: 20px 14px;
        .staff-header {
          .font70 { font-size: 36px;}
          .font50 { font-size: 26px;}
        }
        .staff-banner {
          margin-top: 12px;
          .swiper-slide {
            padding: 0 0 40px 0;
          }
          .staff-item {
            .item-img {
              height: 110px;
            }
            .item-title { font-size: 14px;padding: 8px 10px;}
          }
          >>> .swiper-pagination-bullet {
            width: 10px;height: 10px;margin: 0 10px;
            &:before { width: 4px;height: 4px;top: calc(50% - 2px);left: calc(50% - 2px);}

          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/News.vue